import React from 'react';
import Page from '../containers/Page';
import NewTaskForm  from '../containers/NewTaskForm';

export default () => {

    return (
    <Page title="Add task">
     <NewTaskForm  isVisible={true}/>
    </Page>
);}